import { resolveComponent as _resolveComponent, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "gt-header" }
const _hoisted_2 = { class: "gt-header__wrapper" }
const _hoisted_3 = { class: "gt-header__element gt-header__element--burger" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "gt-header__element gt-header__element--breadcrumbs" }
const _hoisted_6 = { class: "gt-header__element gt-header__element--actions" }
const _hoisted_7 = { class: "gt-header__language" }
const _hoisted_8 = { class: "gt-header__userbar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i_burger = _resolveComponent("i-burger")!
  const _component_sidebar = _resolveComponent("sidebar")!
  const _component_ui_burger = _resolveComponent("ui-burger")!
  const _component_simple_breadcrumbs = _resolveComponent("simple-breadcrumbs")!
  const _component_language_selector = _resolveComponent("language-selector")!
  const _component_user_bar = _resolveComponent("user-bar")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_ui_burger, { ref: "sidebar" }, {
          btn: _withCtx(({ open, isOpen }) => [
            _createElementVNode("div", {
              class: "burger-icon",
              onClick: _withModifiers(($event: any) => (open()), ["prevent"])
            }, [
              _createVNode(_component_i_burger)
            ], 8, _hoisted_4)
          ]),
          sidebar: _withCtx(({ close: closeSidebar }) => [
            _createVNode(_component_sidebar, {
              class: "gt-sidebar--mobile",
              close: closeSidebar
            }, null, 8, ["close"])
          ]),
          _: 1
        }, 512)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_component_simple_breadcrumbs)
      ]),
      _cache[0] || (_cache[0] = _createElementVNode("div", { class: "gt-header__element gt-header__element--logo" }, [
        _createElementVNode("div", { class: "gt-header__logo-wrapper" }, [
          _createElementVNode("img", {
            class: "gt-header__logo",
            src: "/static/app/gt-mobile-logo.svg",
            alt: "tt-logo-image"
          })
        ])
      ], -1)),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_language_selector)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_user_bar)
        ])
      ])
    ])
  ]))
}